// The API rejects work with 507 (Insufficient Storage) once the workspace has no
// disk space left (DEV-1796) — the storage equivalent of the 402 "out of
// credits" path, and handled the same way: the interceptor opens one dialog and
// call sites carry on as if the request simply failed.
export const STORAGE_FULL_STATUS = 507;
export const STORAGE_FULL_IDENTIFIER = "storage_limit_exceeded";

type ErrorResponse = {
  response?: {
    status?: number;
    data?: { identifier?: string };
  };
};

/** Thrown on the fetch paths (chat stream) that never touch the interceptors. */
export class StorageLimitError extends Error {
  readonly response = {
    status: STORAGE_FULL_STATUS,
    data: { identifier: STORAGE_FULL_IDENTIFIER },
  };

  constructor() {
    super("Not enough disk space");
    this.name = "StorageLimitError";
  }
}

export function isOutOfStorageError(error: unknown): boolean {
  if (error instanceof StorageLimitError) return true;
  const response = (error as ErrorResponse | null)?.response;
  return (
    response?.status === STORAGE_FULL_STATUS ||
    response?.data?.identifier === STORAGE_FULL_IDENTIFIER
  );
}

// Registered from React (PlatformDialogs) because the interceptor runs outside
// it, exactly like the billing modals.
let openHandler: (() => void) | null = null;

export function registerStorageLimitDialog(openFn: () => void) {
  openHandler = openFn;
}

export function openStorageLimitDialog() {
  if (typeof window !== "undefined") {
    openHandler?.();
  }
}
